"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findProgramAddress = void 0;
const anchor_1 = require("@project-serum/anchor");
function findProgramAddress(seeds, programId) {
    const [publicKey, bump] = anchor_1.utils.publicKey.findProgramAddressSync(seeds, programId);
    return { publicKey, bump };
}
exports.findProgramAddress = findProgramAddress;
